export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9822.71a47f8d.jpg";